import React from 'react';
import BreadcrumbComp from '@components/UI/Breadcrumb/Index.jsx';
import Create from "./Create.jsx";

function CreateUsuarios({ addItem }) {

  const NomeForm = "Novos Usuários";
  return (
    <div className="row">
      <BreadcrumbComp Param1="Home" Param2="Cadastros & Parâmentros" Param3={NomeForm} />
      <div className="col-12 col-md-12">
        <div className="block h-auto">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-md-6 d-flex align-items-center">
                <h2 className="mb-0">{NomeForm}</h2>
              </div>
              <div className="col-12 col-md-6 d-flex align-items-center justify-content-end">
                <button className="btn btn-menu">
                  <i className="fa-solid fa-bars"></i>
                </button>
              </div>

              <Create onSave={addItem} />

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CreateUsuarios;